import { Image } from "@chakra-ui/image";
import { Box, Text } from "@chakra-ui/layout";
import { useState } from "react";
import { formatDateAnnouncements } from "../../redux/actions/action";

export default function IndividualAnnouncementCard({ dashboard, image, description, title, startingDate, startingTime, department }) {
    const [readMoreClicked, setReadMoreClicked] = useState(false)
    return (
        <Box
            w='100%'
            d='flex'
            // alignItems='center'
            py='1rem'
            borderBottom='1px solid rgba(0, 0, 0, 0.05)'
            justifyContent='space-between'
        >
            <Image
                src={image ? image : './images/unavailable-image.jpg'}
                width='40px'
                height='40px'
                objectFit='cover'
                d={['none', 'none', 'none', 'flex']}
                borderRadius='50%' mr='1rem'
            />

            <Box
                color='#333333'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                display='flex'
                justifyContent='flex-start'
                flexDir='column'
                alignItems='flex-start'
                w='100%'
            >
                <Box d='flex' w='100%' justifyContent='space-between' alignItems='center'>
                    <Text
                        fontWeight='900'
                        fontSize={dashboard ? '14px' : ['11px', '13px', '15px', '16px']}
                        textTransform='uppercase'
                    >
                        {department}
                    </Text>
                    {
                        dashboard &&
                        <Text
                            fontWeight='400' fontSize='14px'
                        >
                            {startingDate ? `${formatDateAnnouncements(startingDate)} at ${startingTime}` : 'N/A'}
                        </Text>
                    }
                </Box>
                <Box d='flex' w='100%' justifyContent='space-between' alignItems='center'>
                    <Text
                        fontWeight='700'
                        fontSize={dashboard ? '14px' : ['11px', '13px', '15px', '16px']}
                    >
                        {title}
                    </Text>
                    {
                        !dashboard &&
                        <Text
                            fontWeight='400' fontSize={['9px', '11px', '14px', '16px']}
                        >
                            {startingDate ? `${formatDateAnnouncements(startingDate)} at ${startingTime}` : 'N/A'}
                        </Text>
                    }
                </Box>
                <Box d='flex' w='100%' justifyContent='space-between' alignItems='flex-end'>
                    {
                        !dashboard ?
                            <Text
                                fontWeight='600'
                                fontSize={dashboard ? '14px' : ['11px', '13px', '15px', '16px']}
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                whiteSpace={!readMoreClicked && 'nowrap'}
                                overflow={!readMoreClicked && 'hidden'}
                                textOverflow={!readMoreClicked && 'ellipsis'}
                                width='100ch'
                            >
                                <em>{description}</em>
                            </Text>
                            :
                            <Text
                                fontWeight='600'
                                fontSize={dashboard ? '14px' : ['11px', '13px', '15px', '16px']}
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                whiteSpace={!readMoreClicked && 'nowrap'}
                                overflow={!readMoreClicked && 'hidden'}
                                textOverflow={!readMoreClicked && 'ellipsis'}
                                width='33ch'
                            >
                                <em>{description}</em>
                            </Text>
                    }
                    {
                        ((!dashboard && description.split(' ').join('').length > 100) || (dashboard && description.split(' ').join('').length > 33)) &&
                        <Text
                            fontWeight='400'
                            fontSize={['11px', '13px', '15px', '16px']}
                            color='#fe5858'
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            cursor='pointer'
                            onClick={() => setReadMoreClicked(!readMoreClicked)}
                        >
                            {readMoreClicked ? 'read less' : 'read more'}
                        </Text>
                    }
                </Box>
            </Box>


        </Box>
    )
}